module.exports = __webpack_public_path__ + "img/spinner.94491c9a.gif";